import * as React from 'react';

export const UserInfo = React.createContext([]);
